import React, { useState, useEffect, useCallback, useContext, memo, useRef } from 'react';
import DatePicker from "react-datepicker";
import { AuthContext } from '../context/authContext';
import { useFormContext } from "../context/FormContext";

import { Input, Label, Button, Select_simple } from "./ui";
import { optionsObjetoExpediente, optionsObjetoExpediente_Proyectos, optionsObjetoExpediente_Mejoras_Microcreditos } from "../datos/options";

// Componentes memoizados para evitar re-renders innecesarios
const MemoizedInput = memo(Input);
const MemoizedSelect = memo(Select_simple);

//const ExpedienteSubform = ({ arrayObrasExpediente = [], onRegistroChange, registro }) => { 
const ExpedienteSubform = () => { //sin props    

    const {user} = useContext(AuthContext);
    const { formA, updateField } = useFormContext();
    console.log("PERRO formA", formA)
    console.log("PERRO formA array_obras_expediente", formA?.array_obras_expediente)
    const { datosGenerales } = formA;

    
    // 1. Usar estado local para manejar los expedientes
    const [expedientes, setExpedientes] = useState(() => {
        const initialData = formA?.array_obras_expediente;
        console.log("GATO initialData Espedientes", initialData)
        return Array.isArray(initialData) && initialData.length > 0
            ? initialData
            : [{
                expediente_o: "",
                objeto_o: "",
                fecha_caratulacion_o: null,
                descripcion_objeto_o: ""
            }];
    });
    /*
    // 2. Sincronizar con el contexto cuando cambie formA.array_obras_expediente
    useEffect(() => {
        if (Array.isArray(formA?.array_obras_expediente)) {
            setExpedientes(formA.array_obras_expediente);
        }
    }, [formA?.array_obras_expediente]);
    */

    //// Sincronizar con el contexto cuando cambia
    useEffect(() => {
        if (Array.isArray(formA?.array_obras_expediente)) {
            setExpedientes(formA.array_obras_expediente);
        }
    }, [formA?.array_obras_expediente]);
    
    // 3. Actualizar el contexto cuando cambien los expedientes
    useEffect(() => {
        if (Array.isArray(expedientes)) {
            updateField('formA', 'array_obras_expediente', null, expedientes);
        }
    }, [expedientes, updateField]);
    

    // 4. Modificar los manejadores para usar setExpedientes
    const handleAddExpediente = useCallback(() => {
        const newExpediente = {
            expediente_o: "",
            objeto_o: "",
            fecha_caratulacion_o: null,
            descripcion_objeto_o: ""
        };
        setExpedientes(prev => [...prev, newExpediente]);
    }, []);
    

    const handleRemoveExpediente = useCallback((index) => {
        if (expedientes.length > 1) {
            setExpedientes(prev => prev.filter((_, i) => i !== index));
        }
    }, [expedientes.length]);
    

    const handleExpedienteChange = useCallback((index, field, value) => {
        setExpedientes(prev => {
            const newExpedientes = [...prev];
            newExpedientes[index] = {
                ...newExpedientes[index],
                [field]: value
            };
            return newExpedientes;
        });
    }, []);
    

    const getOptions = useCallback(() => {
        if (datosGenerales.area_responsable === 'ÁREA DE PROYECTOS') {
            return optionsObjetoExpediente_Proyectos;
        } else if (datosGenerales.area_responsable === 'ÁREA DE MEJORAS' || datosGenerales.area_responsable === 'ÁREA DE MICROCRÉDITOS') {
            return optionsObjetoExpediente_Mejoras_Microcreditos;
        }
        return optionsObjetoExpediente;
    }, [datosGenerales.area_responsable]);    

    
    if (!datosGenerales.area_responsable) {
        return (
            <div className="p-4 bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
                <p className="text-sm text-red-600 dark:text-red-400">
                    <span className="font-medium">Atención:</span> Por favor, seleccione un Área Responsable para continuar.
                </p>
            </div>
        );
    } 

    
    return (          
        <div className="p-4">
            {expedientes?.map((expediente = {}, index) => (
                <div key={index} className="mb-4 border rounded-lg p-4 bg-white dark:bg-gray-800 shadow-sm">
                    {expedientes.length > 0 && (
                        <div className="flex justify-end mt-2">
                            <Button 
                                variant={expedientes.length <= 1 ? "ghost" : "destructive"}
                                size="sm"
                                onClick={() => handleRemoveExpediente(index)} //handleRemoveClick
                                className={`px-2 py-1 text-xs ${expedientes.length <= 1 ? "text-gray-400 cursor-not-allowed" : ""}`}
                                disabled={expedientes.length <= 1}
                            >
                                Eliminar
                            </Button>
                        </div>
                    )}
                    <div className="grid grid-cols-2 gap-4 mb-4">
                        <div>
                            <Label htmlFor="expediente">Expediente</Label>
                            <div className="mt-1">
                                <MemoizedInput
                                    id={`expediente_o_${index}`}
                                    name="expediente_o"
                                    type="text"
                                    placeholder="N° expediente"
                                    value={expediente?.expediente_o || ''}
                                    onChange={(e) => handleExpedienteChange(index, 'expediente_o', e.target.value)}
                                />
                            </div>
                        </div>

                        <div>
                            <Label htmlFor="objetos">Objeto</Label>
                            <div className="mt-1">
                                <Select_simple
                                //options depende de registro.area_responsable
                                    options={getOptions()}
                                    id={`objeto_o_${index}`}
                                    name="objeto_o"
                                    //placeholder="Seleccionar objeto"
                                    value={expediente?.objeto_o || ''}
                                    //value={getOptions().find(option => option.value === expediente.objeto_o) || ''}
                                    onChange={(e) => handleExpedienteChange(index, 'objeto_o', e.target.value)} //{(e) => handleArrayChange(index, e)}
                                />
                            </div>
                        </div>
                    </div>
                    {expediente.objeto_o === 'Adenda' && (
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <Label htmlFor="monto_adenda">Monto adenda</Label>
                                <div className="mt-1">
                                    <MemoizedInput
                                        id={`monto_adenda_${index}`}
                                        name="monto_adenda"
                                        type="number"
                                        placeholder="Monto adenda"
                                        value={expediente?.monto_adenda || ''}
                                        onChange={(e) => handleExpedienteChange(index, 'monto_adenda', e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <Label htmlFor="fecha_caratulacion">Fecha caratulación</Label>
                            <div className="mt-1 w-full">
                                <DatePicker
                                    id={`fecha_caratulacion_o_${index}`}
                                    name="fecha_caratulacion_o"
                                    dateFormat="dd/MM/yyyy"
                                    selected={expediente?.fecha_caratulacion_o ? new Date(expediente.fecha_caratulacion_o) : null}
                                    className="w-full border border-gray-300 rounded-md bg-white dark:bg-gray-800 dark:border-gray-700 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 px-3 h-10"
                                    onChange={(date) => handleExpedienteChange(index, 'fecha_caratulacion_o', date)}
                                    wrapperClassName="w-full"
                                />
                            </div>
                        </div>

                        <div>
                            <Label htmlFor="descripcion_objeto_o">Descripción</Label>
                            <div className="mt-1">
                                <MemoizedInput
                                    id={`descripcion_objeto_o_${index}`}
                                    name="descripcion_objeto_o"
                                    type="text"
                                    placeholder="Descripción breve"
                                    value={expediente?.descripcion_objeto_o || ''}
                                    onChange={(e) => handleExpedienteChange(index, 'descripcion_objeto_o', e.target.value)}
                                />
                            </div>
                        </div>
                    </div>                    
                </div>
            ))}

            <div className="flex justify-end mt-4">
                <button
                    type="button"
                    onClick={handleAddExpediente} //{handleAddClick}
                    className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                >
                    Añadir Expediente
                </button>
            </div>
            
            {user === 'Javier' || user === 'Datos' && (
                <div className="mt-4 p-2 bg-gray-100 rounded">
                    <pre>{JSON.stringify(expedientes, null, 2)}</pre>
                </div>
            )}
        </div>
    );
};

export default memo(ExpedienteSubform);